<ng-container *ngIf="!isLoading;else loadingDataAI">
    <h2 class="text-start" mat-dialog-title style="margin-bottom: 0px !important;">
        {{ 'kyc.image_recognition' | translate}}
        <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
            <span aria-hidden="true">&times;</span>
        </button>
    </h2>
    <mat-divider></mat-divider>

    <div [formGroup]="customerForm" class="pt-2 mx-0" style="margin: unset !important; overflow: hidden !important;">
        <div style="font-size: 16px; color: #444444;" class="mb-2">{{ 'search_form.custommer_type' | translate }}</div>
        <div class="mx-2 mt-2">
            <mat-radio-group (change)="selectCustomerType($event)" formControlName="customerType" required>
                <mat-radio-button class="mr-3" style="font-size: 16px;" value="personal">
                    {{ "contract_lot.customer_type.personal" | translate }}
                </mat-radio-button>
                <mat-radio-button style="font-size: 16px;" value="enterprise">
                    {{ "contract_lot.customer_type.enterprise" | translate }}
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="row mt-3">
            <div *ngFor="let image of listImage; let i = index" class="col-12"
                style="min-width: 12rem; padding-right: 12px;">
                <ng-container *ngIf="image.fileType === customerForm.controls['customerType'].value">
                    <ng-container *ngIf="image.required">
                        <span style="font-size: 16px;">{{ image.fileTitle }}</span> (<span style="color: red;">*</span>)
                    </ng-container>
                    <ng-container *ngIf="!image.required">
                        <span style="font-size: 16px;">{{ image.fileTitle }}</span>
                    </ng-container>
                    <div class="mb-1" style="font-size: 12px;" [innerHTML]="image.fileDescription"></div>
                    <div nz-upload-btn class="mt-2">
                        <div class="clearfix nz-upload-clearfix row" style="margin: 0;">
                            <div style="width: 100%;">
                                <nz-upload style="max-width: 100% !important; position: relative;"
                                    [nzAccept]="image.accept" [nzPreview]="handlePreview" class="avatar-uploader"
                                    [nzCustomRequest]="dummyRequest" nzName="avatar" nzListType="picture-card"
                                    [nzShowUploadList]="false" [nzBeforeUpload]="beforeUpload"
                                    (nzChange)="handleChange($event, i)">
                                    <ng-container *ngIf="!image.fileContentBase64">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <i class="upload-icon mr-3" nz-icon [nzType]="'plus'"></i>
                                            <span class="ant-upload-text">Upload</span>
                                        </div>
                                        <div class="mt-2" style="font-size: 12px; font-style: italic;"
                                            [innerHTML]="image.fileDescription"></div>
                                    </ng-container>
                                    <div *ngIf="image.fileContentBase64" style="height: 10rem; position: relative;">
                                        <div style="width: 100%; height: 100%;"
                                            class="img-thumbnail d-flex justify-content-center align-items-center"
                                            #imageIndentify>
                                            <ng-container
                                                *ngIf="image.fileContentBase64.includes('application/pdf');else fileImage">
                                                <svg width="96" height="96" viewBox="0 0 16 16" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M14.0826 8.90926H1.92398L1.01208 7.6934L2.22795 6.47754H13.7786L14.9945 7.6934L14.0826 8.90926Z"
                                                        fill="#870000" />
                                                    <path
                                                        d="M13.1718 14.9887H2.837C2.50111 14.9887 2.22906 14.7167 2.22906 14.3808V1.61428C2.22906 1.2784 2.50111 1.00635 2.837 1.00635H10.1322L13.7797 4.65393V14.3808C13.7797 14.7167 13.5077 14.9887 13.1718 14.9887Z"
                                                        fill="#e3e3e3" />
                                                    <path
                                                        d="M10.1322 1.00635V4.046C10.1322 4.38188 10.4043 4.65393 10.7401 4.65393H13.7798L10.1322 1.00635Z"
                                                        fill="#CDCDCD" />
                                                    <path
                                                        d="M14.3865 13.1647H1.62002C1.28413 13.1647 1.01208 12.8927 1.01208 12.5568V7.69336H14.9945V12.5568C14.9945 12.8927 14.7224 13.1647 14.3865 13.1647Z"
                                                        fill="#BD0100" />
                                                    <path
                                                        d="M6.80945 10.0176C6.80945 10.2845 6.73072 10.4906 6.57357 10.6356C6.41612 10.7812 6.193 10.8535 5.90333 10.8535H5.72216V11.6453H5.07715V9.2583H5.90333C6.20486 9.2583 6.43131 9.32426 6.58238 9.45557C6.73376 9.5875 6.80945 9.77504 6.80945 10.0176ZM5.72216 10.328H5.8398C5.93676 10.328 6.01367 10.3006 6.07081 10.2459C6.12796 10.1915 6.15653 10.1164 6.15653 10.0209C6.15653 9.85985 6.06747 9.7793 5.88874 9.7793H5.72216V10.328Z"
                                                        fill="white" />
                                                    <path
                                                        d="M9.21581 10.4012C9.21581 10.7997 9.10608 11.1064 8.88661 11.3219C8.66745 11.5377 8.35923 11.6453 7.96195 11.6453H7.18958V9.2583H8.01575C8.39875 9.2583 8.69451 9.35618 8.90303 9.55224C9.11155 9.74829 9.21581 10.031 9.21581 10.4012ZM8.54648 10.424C8.54648 10.2052 8.50331 10.0431 8.41668 9.93736C8.33036 9.83158 8.19874 9.77899 8.02244 9.77899H7.83459V11.1158H7.97836C8.17442 11.1158 8.31789 11.0587 8.40939 10.945C8.50088 10.8313 8.54648 10.6581 8.54648 10.424Z"
                                                        fill="white" />
                                                    <path
                                                        d="M10.2796 11.6453H9.64459V9.2583H11.0553V9.77565H10.2799V10.2313H10.9951V10.7486H10.2799V11.6453H10.2796Z"
                                                        fill="white" />
                                                </svg>
                                                <div class="fullscreen-icon">
                                                    <mat-icon matTooltip="{{'kyc.fullscreen_tooltip' | translate}}"
                                                        class="full-icon"
                                                        (click)="previewPdf({ fileName: image.fileName, filePathBase64: image.fileContentBase64 }, $event)">
                                                        fullscreen</mat-icon>
                                                </div>
                                            </ng-container>
                                            <ng-template #fileImage>
                                                <img [src]="sanitize(image.fileContentBase64)"
                                                    style="max-width: 100%; max-height: 100%; display: block; object-fit: contain;" />
                                                <div class="fullscreen-icon">
                                                    <mat-icon matTooltip="{{isModeImage === 'normal' ? ('kyc.fullscreen_tooltip' | translate) : ('button.close' | translate)}}"
                                                    class="full-icon" (click)="toggleFullscreen(imageIndentify, $event)">
                                                    {{ isModeImage === 'normal' ? 'fullscreen' : 'close' }}</mat-icon>
                                                </div>
                                            </ng-template>
                                        </div>
                                    </div>
                                </nz-upload>
                                <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContent" [nzFooter]="null"
                                    (nzOnCancel)="previewVisible = false">
                                    <ng-template #modalContent>
                                        <div *ngIf="image.fileContentBase64" style="height: 10rem; position: relative;">
                                            <div style="width: 100%; height: 100%;"
                                                class="img-thumbnail d-flex justify-content-center align-items-center"
                                                #imageIndentify>
                                                <img [src]="sanitize(image.fileContentBase64)"
                                                    style="max-width: 100%; max-height: 100%; display: block; object-fit: contain;" />
                                                <div class="fullscreen-icon">
                                                    <mat-icon matTooltip="{{'kyc.fullscreen_tooltip' | translate}}"
                                                        class="full-icon"
                                                        (click)="toggleFullscreen(imageIndentify, $event)">fullscreen
                                                    </mat-icon>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </nz-modal>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="image.fileContentBase64">
                        <div class="d-flex w-full justify-content-between">
                            <div class="fix-width ">
                                <span class="" [matTooltip]="image.fileName">
                                    <em class="fa fa-file fa-fw text-primary"></em>
                                    {{image.fileName}}
                                </span>
                            </div>
                            <div class="ml-2 d-flex" style="width: 50%; justify-content: flex-end; min-width: 6rem;">
                                <span class="pr-1">
                                    {{image.fileSize | byte}}
                                </span>
                                <span>
                                    <button class="btn-none" type="button">
                                        <em class="fa fa-trash fa-fw text-danger" (click)="deleteImage(i)"
                                            matTooltip="{{'tooltips.delete' | translate}}"></em>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>


    <div mat-dialog-actions class="justify-content-center">
        <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
            <mat-icon>cancel</mat-icon>
            {{'button.cancel' | translate}}
        </button>
        <button mat-raised-button type="button" (click)="AiIdentification()" color="primary">
            <mat-icon>save</mat-icon>
            {{'button.save_2' | translate}}
        </button>
    </div>
</ng-container>

<ng-template #loadingDataAI>
    <h2 class="text-start" mat-dialog-title style="margin-bottom: 0px !important;">
        {{ 'kyc.perform_AI_recognition' | translate}}
        <button type="button" class="close" aria-label="Close" (click)="cancelAIRecognition()">
            <span aria-hidden="true">&times;</span>
        </button>
    </h2>
    <mat-divider></mat-divider>

    <div class="mt-3 mb-1">{{ 'kyc.AI_processing' | translate }}</div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>

    <div mat-dialog-actions class="justify-content-center mt-3">
        <button mat-raised-button type="button" (click)="cancelAIRecognition()" color="primary">
            <mat-icon>cancel</mat-icon>
            {{'button.cancel' | translate}}
        </button>
    </div>
</ng-template>